import React from "react"
import { useState } from "react"
import AsyncSelect from "react-select/async"
import DatePicker from "react-datepicker"
import { Button, ButtonGroup, Col, Modal, ModalBody, ModalHeader } from "reactstrap"
import { getAuthorizationToken } from "helpers/storagehelper"
import { useEffect } from "react"
import MoveIDFVorm from "./moveId_Manual_Form"
import { customStylesSelect } from "../../../common/data/settings"
import toast from "toastr"

// Toggle to re-enable the informational penalties panel in the attendance modal.
// Hidden at management's request; data fetching stays wired so this is a one-line switch.
const SHOW_PENALTIES = false

const TimeLogFilter = ({
  handleChange,
  authUser,
  formData,
  toSelectData,
  clickedRow,
  clickedRowToggle,
  getTimeLogByDate,
  showDeviceFilter,
  deviceFilter,
  setDeviceFilter,
}) => {
  const [allUsers, setAllUser] = useState([])
  useEffect(() => {
    getUserListData(authUser.data?.firstname.substr(0, 3), () => {}, undefined)
  }, [])
  const getUserListData = async (
    searchValue,
    callback,
    searchKey = "useremail"
  ) => {
    try {
      const data = await fetch(
        `${process.env.REACT_APP_API_URL}/Users/GetUsers`,
        {
          method: "post",
          headers: {
            Authorization: `Bearer ${getAuthorizationToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            searchKey,
            searchValue,
            pageNumber: 0,
            pageSize: 20,
          }),
        }
      )
        .then(res => res.json())
        .then(res => {
          setAllUser(res.data)
          return res.data.map(el => ({
            ...el,
            label: el.username,
            value: el.id,
          }))
        })
      callback(data)
      return data
    } catch (err) {
      console.log(err, "err")
      return []
    }
  }

  const loadOptions = (inputValue, callback) => {
    getUserListData(inputValue, callback)
  }
  const selectedUser = allUsers.filter(el => el.id === formData.userId)[0]

  const [modal, setModal] = useState(false)
  const [headerTitle, setHeaderTitle] = useState(null)
  const [isVisibleTiming, setIsVisibleTiming] = useState(false)
  const [auditLogModal, setAuditLogModal] = useState(false)
  const [auditLogs, setAuditLogs] = useState([])
  const [loadingAuditLogs, setLoadingAuditLogs] = useState(false)
  const [syncStatus, setSyncStatus] = useState(null)
  const [loadingSyncStatus, setLoadingSyncStatus] = useState(false)
  const [updatingAttendance, setUpdatingAttendance] = useState(false)
  const [penalties, setPenalties] = useState(null)
  const [loadingPenalties, setLoadingPenalties] = useState(false)

  // ERP attendance for the selected date is editable only while it is still in Draft
  // (or not yet created). Fetch that state to drive the "Update Attendance to ERP" button.
  const fetchSyncStatus = async () => {
    setLoadingSyncStatus(true)
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Attendance/GetUserAttendanceSyncStatus`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${getAuthorizationToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: String(formData.userId),
            date: formData.Date,
          }),
        }
      )
      const result = await response.json()
      setSyncStatus(result.statusCode === 200 ? result.data : null)
    } catch (error) {
      console.error("Error fetching attendance sync status:", error)
      setSyncStatus(null)
    } finally {
      setLoadingSyncStatus(false)
    }
  }

  // Penalties applicable for the current attendance state of the selected date. These are
  // informational only — the API computes them in preview mode and does NOT push them to ERP.
  const fetchPenalties = async () => {
    setLoadingPenalties(true)
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Attendance/GetUserAttendancePenalties`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${getAuthorizationToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: String(formData.userId),
            date: formData.Date,
          }),
        }
      )
      const result = await response.json()
      setPenalties(result.statusCode === 200 ? result.data : null)
    } catch (error) {
      console.error("Error fetching applicable penalties:", error)
      setPenalties(null)
    } finally {
      setLoadingPenalties(false)
    }
  }

  // ERP sync status and penalties are only surfaced to admins, so skip the
  // fetches entirely for non-admin users.
  useEffect(() => {
    if (
      authUser.data.accessgroupname === "Admin" &&
      formData?.userId &&
      formData?.Date
    ) {
      fetchSyncStatus()
      fetchPenalties()
    }
  }, [formData?.userId, formData?.Date])

  const handleUpdateAttendance = async () => {
    setUpdatingAttendance(true)
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Attendance/UpdateAttendanceByUser`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${getAuthorizationToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: String(formData.userId),
            date: formData.Date,
          }),
        }
      )
      const result = await response.json()
      if (result.statusCode === 200) {
        toast.success(result.message || "Attendance updated to ERP.")
        fetchSyncStatus()
        fetchPenalties()
        if (typeof getTimeLogByDate === "function") getTimeLogByDate()
      } else {
        toast.error(result.message || "Failed to update attendance to ERP.")
      }
    } catch (error) {
      console.error("Error updating attendance to ERP:", error)
      toast.error("Failed to update attendance to ERP.")
    } finally {
      setUpdatingAttendance(false)
    }
  }

  const handleTimeEntry = title => {
    setIsVisibleTiming(title === "Change Status" ? true : false)
    setModal(true)
    setHeaderTitle(title)
  }

  const fetchAuditLogs = async () => {
    setLoadingAuditLogs(true)
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/AuditLog/GetAuditLogs`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${getAuthorizationToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userid: formData.userId,
            date: formData.Date,
          }),
        }
      )
      const result = await response.json()
      if (result.statusCode === 200) {
        setAuditLogs(result.data || [])
      } else {
        setAuditLogs([])
      }
    } catch (error) {
      console.error("Error fetching audit logs:", error)
      setAuditLogs([])
    } finally {
      setLoadingAuditLogs(false)
    }
  }

  const handleAuditLogClick = () => {
    setAuditLogModal(true)
    fetchAuditLogs()
  }

  return (
    <Col sm="12" className="d-flex justify-content-end mobile_work_filter">
      <div className="w-100 mb-4">
        <div className="d-flex mobile_responsive_filter timelog-customize-header">
          <div className="mx-2 timlog-date">
            <DatePicker
              dateFormat="yyyy-MM-dd"
              selected={new Date(formData.Date)}
              onChange={value => handleChange(value, "Date")}
              className="form-control mb-0 date-icon-back"
              placeholderText="Select date"
              maxDate={new Date()}
            />
          </div>
          {authUser.data.accessgroupname !== "User" &&
            authUser.data.accessgroupname !== "Supervisor" && (
              <div className="mx-2 w-25 timelog-select">
                <AsyncSelect
                  // isMulti
                  styles={customStylesSelect}
                  value={{
                    ...selectedUser,
                    label: selectedUser?.username,
                    value: selectedUser?.id,
                  }}
                  onChange={value => handleChange(value, "userId")}
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions={(allUsers || [])?.map(el => ({
                    ...el,
                    label: el.username,
                    value: el.id,
                  }))}
                  classNamePrefix="select2-selection"
                  className="add_Zindex_one "
                />
              </div>
            )}
          {showDeviceFilter && (
            <div className="mx-2 d-flex align-items-center">
              <ButtonGroup size="sm">
                {["All", "Primary", "Others"].map(option => (
                  <Button
                    key={option}
                    type="button"
                    color="primary"
                    outline={deviceFilter !== option}
                    active={deviceFilter === option}
                    onClick={() => setDeviceFilter(option)}
                  >
                    {option}
                  </Button>
                ))}
              </ButtonGroup>
            </div>
          )}
          <div className="d-flex timelog-buttons">
            {clickedRowToggle && (
              <div className="text-sm-end">
                <Button
                  type="button"
                  color="primary"
                  className="btn-rounded mb-2 me-2"
                  onClick={() => handleTimeEntry("Change Status")}
                >
                  <i className="mdi mdi-plus me-1" />
                  Change Status
                </Button>
              </div>
            )}
            <div className="text-sm-end">
              <Button
                type="button"
                color="primary"
                className="btn-rounded mb-2 me-2"
                onClick={() => handleTimeEntry("Move ID / Hrs")}
              >
                <i className="mdi mdi-plus me-1" />
                Move ID / Hrs
              </Button>
            </div>
            <div className="text-sm-end">
              <Button
                type="button"
                color="primary"
                className="btn-rounded mb-2 me-2"
                onClick={() => handleTimeEntry("Add Manual Entry")}
              >
                <i className="mdi mdi-plus me-1" />
                Add Manual Entry
              </Button>
            </div>
            <div className="text-sm-end">
              <Button
                type="button"
                color="info"
                className="btn-rounded mb-2 me-2"
                onClick={handleAuditLogClick}
              >
                <i className="mdi mdi-file-document-outline me-1" />
                Audit Log
              </Button>
            </div>
            {/* Update Attendance action and ERP status label are admin-only */}
            {authUser.data.accessgroupname === "Admin" && (
              <div className="text-sm-end d-flex align-items-center">
                <Button
                  type="button"
                  color="success"
                  className="btn-rounded mb-2 me-2"
                  onClick={handleUpdateAttendance}
                  disabled={
                    updatingAttendance ||
                    loadingSyncStatus ||
                    !syncStatus?.canUpdate
                  }
                  title={
                    syncStatus && !syncStatus.canUpdate
                      ? "Attendance is already submitted in ERP and can no longer be updated."
                      : "Update attendance & timesheet to ERP for the selected date"
                  }
                >
                  <i className="mdi mdi-cloud-upload-outline me-1" />
                  {updatingAttendance ? "Updating..." : "Update Attendance"}
                </Button>
                {syncStatus && (
                  <span
                    className={`badge mb-2 me-2 ${
                      syncStatus.docStatusLabel === "Submitted"
                        ? "bg-secondary"
                        : "bg-warning"
                    }`}
                    title={`ERP status: ${syncStatus.docStatusLabel}`}
                  >
                    {syncStatus.docStatusLabel === "NotCreated"
                      ? "Not Synced"
                      : syncStatus.docStatusLabel}
                  </span>
                )}
              </div>
            )}
          </div>
          {/* Possible penalties for the current attendance state — informational only,
              these are NOT pushed to ERP by the Update Attendance action.
              Hidden at management's request (users read it as "already applied").
              Integration is kept intact — flip SHOW_PENALTIES to true to re-enable. */}
          {SHOW_PENALTIES && formData?.userId && formData?.Date && (
            <div className="mb-2 p-2 border rounded bg-light">
              <div className="d-flex align-items-center mb-1">
                <i className="mdi mdi-alert-circle-outline text-warning me-1" />
                <strong className="me-2">Possible penalties</strong>
                <small className="text-muted">(not pushed to ERP)</small>
              </div>
              {loadingPenalties ? (
                <small className="text-muted">Loading penalties…</small>
              ) : penalties && penalties.penalties && penalties.penalties.length > 0 ? (
                <>
                  <ul className="mb-1 ps-3">
                    {penalties.penalties.map((p, i) => (
                      <li key={i}>
                        {p.type} — {p.points} {p.pointType}
                        {p.reason ? (
                          <small className="text-muted"> ({p.reason})</small>
                        ) : null}
                      </li>
                    ))}
                  </ul>
                  <strong>
                    Total: {penalties.totalABP} ABP, {penalties.totalVPP} VPP
                  </strong>
                </>
              ) : (
                <small className="text-success">
                  No penalties for the selected date.
                </small>
              )}
            </div>
          )}
          <div>
            <Modal isOpen={modal} size="lg">
              <ModalHeader tag="h4">{headerTitle}</ModalHeader>
              <ModalBody>
                <MoveIDFVorm
                  setModal={setModal}
                  entryName={headerTitle}
                  toSelectData={toSelectData}
                  clickedRow={clickedRow}
                  clickedRowToggle={clickedRowToggle}
                  formData={formData}
                  isVisibleTiming={isVisibleTiming}
                  getTimeLogByDate={getTimeLogByDate}
                />
              </ModalBody>
            </Modal>
          </div>
          <div>
            <Modal isOpen={auditLogModal} size="xl" toggle={() => setAuditLogModal(false)}>
              <ModalHeader tag="h4" toggle={() => setAuditLogModal(false)}>
                Audit Log
              </ModalHeader>
              <ModalBody>
                {loadingAuditLogs ? (
                  <div className="text-center p-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : auditLogs.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th style={{ width: "20%" }}>Timestamp</th>
                          <th style={{ width: "80%" }}>Activity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {auditLogs.map((log, index) => (
                          <tr key={log.id || index}>
                            <td>{new Date(log.timestamp).toLocaleString()}</td>
                            <td>{log.audittext}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center p-4">
                    <p className="text-muted">No audit log entries found for the selected date.</p>
                  </div>
                )}
              </ModalBody>
            </Modal>
          </div>
        </div>
      </div>
    </Col>
  )
}

export default TimeLogFilter
